import { format } from 'date-fns'

interface FormatDateOptions {
  timeOptions?: Intl.DateTimeFormatOptions
  dateOptions?: Intl.DateTimeFormatOptions
  locale?: string
}

export const formatDate = (value: string, options: FormatDateOptions = {}) => {
  const { locale = 'en-US', timeOptions, dateOptions } = options

  const date = new Date(value)

  const defaultTimeOptions: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'UTC'
  }

  const defaultDateOptions: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC'
  }

  const time = date.toLocaleString(locale, timeOptions || defaultTimeOptions)
  const fullDate = date.toLocaleString(locale, dateOptions || defaultDateOptions)
  const utcOffset = `UTC${format(date, 'XXX')}`

  return {
    time,
    fullDate,
    utcOffset
  }
}

export function formatToIsoWithoutMs(date: Date) {
  return date.toISOString().split('.')[0]
}
